import script from "./auto-address-wrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./auto-address-wrapper.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__